export default "__VITE_ASSET__d3bd7b90__"